// Thin wrapper around shared/biome that exposes "the current theme" as a
// module-level singleton so scene/render/audio can read it without passing
// it through every function signature.

import { biomeForDate, type BiomeTheme } from "@shared/biome";
import { courseDateAt } from "@shared/course";

let active: BiomeTheme = biomeForDate(courseDateAt(Date.now()));

export function currentTheme(): BiomeTheme {
  return active;
}

export function setActiveTheme(t: BiomeTheme): void {
  active = t;
}
